const isMobile = (window: Window) =>
  Boolean(window.navigator.userAgent.match(/Mobi/i));

export default isMobile;
